import { styled } from '@mui/system';
import { Stack } from '@mui/material';

export const SearchSection = styled(Stack)({
  marginBottom: '20px',
});